import { Tab, Tabs } from '@mui/material'
import ChecklistOutlinedIcon from '@mui/icons-material/ChecklistOutlined'
import {
  CommunityOutlinedIcon,
  EyeIcon,
  LightbulbOutlinedIcon,
  BeakerOutlinedIcon,
  WaterUtilityOutlinedIcon,
} from '../../icons'
import { useLocation } from 'react-router'
import { FC } from 'react'

interface ProfileNavigationTabsProps {
  mobile?: boolean;
  onChange: (e, value) => void;
}

export const ProfileNavigationTabs:FC<ProfileNavigationTabsProps> = ({mobile, onChange}) => {
  const location = useLocation()


  return (
    <Tabs
      centered
      value={location.pathname}
      onChange={onChange}
      variant={mobile? 'fullWidth' : 'standard'}
      slotProps={{
        indicator:{
          sx:{
            width: mobile ? '4px !important' : '100%', // Example height for the indicator
          }}
      }}
      role="navigation"
      orientation={mobile ? 'vertical' : 'horizontal'}>
      {/* SIPP-846: tab order is Recommendations → Overview → Test results →
          Signals → Utility Info → Community. Recommendations leads as the
          marquee/conversion tab; Overview is the secondary landing; the
          data drill-downs follow in narrowing scope; Community trails as
          the exploratory tab. The Insights tab was renamed to Signals to
          match the data card label introduced in SIPP-836. The
          /profile/insights route is unchanged so existing bookmarks,
          share links, and CIO/Klaviyo email links keep working. */}
      <Tab
        label="Recommendations"
        value="/profile/recommendations"
        icon={<ChecklistOutlinedIcon color="primary" fontSize="small" />}
        iconPosition="start"
      ></Tab>
      <Tab
        label="Overview"
        value="/profile/overview"
        icon={<EyeIcon color="primary" fontSize="small" />}
        iconPosition="start"
      ></Tab>
      <Tab
        label="Test results"
        value="/profile/results"
        icon={<BeakerOutlinedIcon color="primary" fontSize="small" />}
        iconPosition="start"
      ></Tab>
      <Tab
        label="Signals"
        value="/profile/insights"
        icon={<LightbulbOutlinedIcon color="primary" fontSize="small" />}
        iconPosition="start"
      ></Tab>
      <Tab
        label="Utility Info"
        value="/profile/info"
        icon={<WaterUtilityOutlinedIcon color="primary" fontSize="small" />}
        iconPosition="start"
      />
      <Tab
        label="Community"
        value="/profile/community"
        icon={<CommunityOutlinedIcon color="primary" fontSize="small" />}
        iconPosition="start"
      />
    </Tabs>
  )
}